import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  cards: null,
  banks: null,
  wallets: null,

  addPresetStatus: '',
  updatePresetStatus: '',
  removePresetStatus: '',
};

export const presetsSlice = createSlice({
  name: 'presets',
  initialState,
  reducers: {
    setCardPresets: (state, action) => {
      state.cards = action.payload;
    },
    setBankPresets: (state, action) => {
      state.banks = action.payload;
    },
    setCryptoPresets: (state, action) => {
      state.wallets = action.payload;
    },

    setAddPresetStatus: (state, action) => {
      state.addPresetStatus = action.payload;
    },
    setUpdatePresetStatus: (state, action) => {
      state.updatePresetStatus = action.payload;
    },
    setRemovePresetStatus: (state, action) => {
      state.removePresetStatus = action.payload;
    },

    resetPresets: () => initialState,
  },
});

export const {
  setCardPresets,
  setBankPresets,
  setCryptoPresets,

  setAddPresetStatus,
  setUpdatePresetStatus,
  setRemovePresetStatus,

  resetPresets,
} = presetsSlice.actions;

export default presetsSlice.reducer;
